<!-- app.component.html -->
<div class="flow-container">
  <div class="container">
    <!-- Mission Section -->
    <section class="info-section">
      <div class="info-image">
        <img src="https://www.csrgs.org/assets/images/mission.jpg" alt="Mission Image" loading="lazy" />
      </div>
      <div class="info-text">
        <h2>Our Mission</h2>
        <p>
          The school is managed by <strong>Jai Bharti Bahuudheyshiya Sevabhavi Pratishthan</strong>. We believe in the
          ancient Indian culture and strive to build national character with respect for parents, teachers, and the
          motherland.
        </p>
        <p>
          Our mission is to develop healthy habits and essential skills for personal growth. We emphasize social
          responsibility and cultivate good manners in a supportive environment.
        </p>
        <p>
          We aim to provide quality education that motivates students to pursue higher studies, while becoming humane
          individuals who contribute positively to society.
        </p>
      </div>
    </section>

    <!-- Vision Section -->
    <section class="info-section reverse">
      <div class="info-image">
        <img src="https://www.csrgs.org/assets/images/vision.jpg" alt="Vision Image" loading="lazy" />
      </div>
      <div class="info-text">
        <h2>Our Vision</h2>
        <p>
          Our vision is to nurture well-rounded, confident individuals who achieve their full potential. We encourage
          excellence while emphasizing care for others and effective communication within our school community.
        </p>
        <p>
          We strive to bring out each child's best and shape them into ideal citizens – the shining gems of society.
        </p>
      </div>
    </section>
  </div>
  <!-- Achievements Carousel -->
  <section class="carousel-section">
    <h2>Achievements</h2>
    <div class="carousel">
      <div class="carousel-track">
        @for (ach of achievementImages; track ach.photoURL; let i = $index) {
        <img [src]="ach.photoURL" alt="Achievement" loading="lazy" />
        }
      </div>
    </div>
  </section>

  <!-- Events Carousel -->
  <section class="carousel-section">
    <h2>Events</h2>
    <div class="carousel">
      <div class="carousel-track">
        @for (event of eventImages; track event.photoURL; let i = $index) {
        <img [src]="event.photoURL" alt="Event" loading="lazy" />
        }
      </div>
    </div>
  </section>
</div>